import React from "react";
import { Textarea, TextareaProps } from "../../textarea";
import {
    FormFieldController,
    FormFieldControllerProps,
} from "../form-field-controller";
import { getMaxLength } from "../hooks";

export type FormTextareaProps = FormFieldControllerProps<TextareaProps>;

export const FormTextarea: React.FC<FormTextareaProps> = ({
    validation,
    name,
    ref,
    maxLength,
    ...textareaProps
}) => {
    const max = getMaxLength(validation?.maxLength) ?? maxLength;
    return (
        <FormFieldController name={name} validation={validation}>
            <Textarea
                fieldId={name}
                {...textareaProps}
                maxLength={max}
                forceControlledMode
            />
        </FormFieldController>
    );
};
